import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialBlockGoogleplusIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialBlockGoogleplus",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.99 24.75A5.3 5.3 0 0 1 24.75 30H7.24c-2.88-.04-5.21-2.37-5.24-5.24V7.25A5.31 5.31 0 0 1 7.23 2h17.5a5.3 5.3 0 0 1 5.25 5.24v17.51zM18.6 15.01h-6.61v2.4h4a3.76 3.76 0 0 1-3.68 3.01c-.1 0-.19 0-.29-.01h.01c-2.34-.12-4.19-2.04-4.19-4.4s1.85-4.29 4.18-4.41h.11c1.04 0 1.99.4 2.69 1.06s1.89-1.84 1.89-1.84a6.75 6.75 0 0 0-4.61-1.81h-.07c-3.86 0-7 3.13-7 7s3.13 7 7 7h.27c3.57 0 6.46-2.89 6.46-6.46 0-.14 0-.27-.01-.41v.02c0-.42-.04-.82-.1-1.22v.05l-.05.01Zm8.39 2.04v-2.04h-1.98V13H23v2h-2v2.05h2v2h2.01v-2H27z"
    })
  }));
};
SocialBlockGoogleplusIcon.displayName = 'SocialBlockGoogleplusIcon';